import { render } from "./physical-store-property-form.vue?vue&type=template&id=73399efc&scoped=true&ts=true"
import script from "./physical-store-property-form.vue?vue&type=script&lang=ts"
export * from "./physical-store-property-form.vue?vue&type=script&lang=ts"

import "./physical-store-property-form.vue?vue&type=style&index=0&id=73399efc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73399efc"]])

export default __exports__